import { Reward } from '@api/Rewards/Reward';
import RewardServ from '@api/Rewards/RewardServ';

class RewardsService {
    saveReward = (reward: Reward): Promise<Reward> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await RewardServ.saveReward(reward);
                resolve(data);
            } catch (error) {
                reject('Error saving reward: ' + error);
            }
        });
    };
    getRewards = (): Promise<Reward | undefined> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await RewardServ.getRewards();
                resolve(data);
            } catch (error) {
                reject('Error getting rewards: ' + error);
            }
        });
    };
}
export default RewardsService;
